import React from "react";

const Wastedvaccine = ({ width, height, color }) => {
  return (
    <svg
      width="65"
      height="70"
      viewBox="0 0 65 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.0714 26.6667V71.1111H13.9286V26.6667H51.0714ZM44.1071 0H20.8929L16.25 4.44444H0V13.3333H65V4.44444H48.75L44.1071 0ZM60.3571 17.7778H4.64286V71.1111C4.64286 76 8.82143 80 13.9286 80H51.0714C56.1786 80 60.3571 76 60.3571 71.1111V17.7778Z"
        fill="#A3A4A3"
      />
    </svg>
  );
};

export default Wastedvaccine;
